import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unknown-error',
  templateUrl: './unknown-error.component.html',
  styleUrls: ['./unknown-error.component.css']
})
export class UnknownErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
